import React from 'react';
import TypeAhead from './typeahead';
import { Field } from 'redux-form';
import { typeahead_location } from '../../../ducks/Shared';

const LocationTypeAhead = function (props) {
  return (
    <TypeAhead
      {...props}
      loadOptions={(search, callback) => {
        const propertyClass = props.propertyClass;
        return typeahead_location({ search, propertyClass }, callback);
      }}
    />
  );
};

const LocationTypeAheadField = props => {
  return (
    <Field
      name="address"
      type="text"
      placeholder="Address, City, MLS #, Neighborhood, Zip"
      propertyClass="residential"
      component={LocationTypeAhead}
      onBlur={() => {}}
      format={value => {
        try {
          let newValue = JSON.parse(value);
          value = newValue;
        } catch (e) {}

        return value;
      }}
      parse={value => {
        if (value === '') {
          return value;
        }

        return JSON.stringify(
          typeof value === 'string'
            ? {
                value,
                field: 'all'
              }
            : {
                value: value.value,
                field: value.field
              }
        );
      }}
      {...props}
    />
  );
};

export { LocationTypeAheadField };
export default LocationTypeAhead;



// WEBPACK FOOTER //
// ./src/components/form/field/location-typeahead.js